import React from "react";
import clsx from "clsx";

interface TitleTextProps {
    text: string;
    className?: string;
}

export const TitleText = (props: TitleTextProps) => {
    return <div className={clsx(props.className, "font-poppins font-semibold text-center text-lg leading-[1] transform-gpu my-0")}>{props.text}</div>;
};
